import { IGenericObject } from '../tests';
import {
  formationPlaceType,
  noFormationPlaceType,
  NO_FORMATION_PLACE,
  FORMATION_3142,
  FORMATION_3241,
  FORMATION_3331,
  FORMATION_3412,
  FORMATION_3421,
  FORMATION_343,
  FORMATION_343D,
  FORMATION_3511,
  FORMATION_352,
  FORMATION_41212,
  FORMATION_4132,
  FORMATION_4141,
  FORMATION_4222,
  FORMATION_4231,
  FORMATION_4240,
  FORMATION_4312,
  FORMATION_4321,
  FORMATION_433,
  FORMATION_4411,
  FORMATION_442,
  FORMATION_451,
  FORMATION_532,
  FORMATION_541,
  teamFormation,
  KEEPER,
  CENTRE_BACK,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_RIGHT,
  FULL_BACK_LEFT,
  SWEEPER,
  WING_BACK_RIGHT,
  WING_BACK_LEFT,
  CENTRE_MIDFIELD,
  CENTRE_MIDFIELD_LEFT,
  CENTRE_MIDFIELD_RIGHT,
  SIDE_MIDFIELD_RIGHT,
  SIDE_MIDFIELD_LEFT,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD_LEFT,
  DEFENSIVE_MIDFIELD,
  OFFENSIVE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD,
  CENTRE_FORWARD_LEFT,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD,
  WINGER_RIGHT,
  WINGER_LEFT,
  SECOND_STRIKER,
  STRIKER,
  STRIKER_RIGHT,
  STRIKER_LEFT,
} from "@sky-it-livedata/livedata-sports-design-system";



export const formationSchemaDefault: { [key: string]: any } = {
  [FORMATION_3142]: {
    1: KEEPER,
    2: CENTRE_BACK_RIGHT,
    3: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    5: DEFENSIVE_MIDFIELD,
    6: WING_BACK_RIGHT,
    7: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_LEFT,
    9: WING_BACK_LEFT,
    10: STRIKER_RIGHT,
    11: STRIKER_LEFT,
  },
  [FORMATION_3241]: {
    1: KEEPER,
    2: CENTRE_BACK_RIGHT,
    3: SWEEPER,
    4: CENTRE_BACK_LEFT,
    5: DEFENSIVE_MIDFIELD_RIGHT,
    6: DEFENSIVE_MIDFIELD_LEFT,
    7: SIDE_MIDFIELD_RIGHT,
    8: OFFENSIVE_MIDFIELD_RIGHT,
    9: OFFENSIVE_MIDFIELD_LEFT,
    10: SIDE_MIDFIELD_LEFT,
    11: CENTRE_FORWARD,
  },
  [FORMATION_3331]: {
    1: KEEPER,
    2: CENTRE_BACK_RIGHT,
    3: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    5: DEFENSIVE_MIDFIELD_RIGHT,
    6: DEFENSIVE_MIDFIELD,
    7: DEFENSIVE_MIDFIELD_LEFT,
    8: WINGER_RIGHT,
    9: OFFENSIVE_MIDFIELD,
    10: WINGER_LEFT,
    11: CENTRE_FORWARD,
  },
  [FORMATION_3412]: {
    1: KEEPER,
    2: CENTRE_BACK_RIGHT,
    3: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    5: WING_BACK_RIGHT,
    6: DEFENSIVE_MIDFIELD_RIGHT,
    7: DEFENSIVE_MIDFIELD_LEFT,
    8: WING_BACK_LEFT,
    9: OFFENSIVE_MIDFIELD,
    10: CENTRE_FORWARD_RIGHT,
    11: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_3421]: {
    1: KEEPER,
    2: CENTRE_BACK_RIGHT,
    3: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    5: WING_BACK_RIGHT,
    6: DEFENSIVE_MIDFIELD_RIGHT,
    7: DEFENSIVE_MIDFIELD_LEFT,
    8: WING_BACK_LEFT,
    9: OFFENSIVE_MIDFIELD_RIGHT,
    10: OFFENSIVE_MIDFIELD_LEFT,
    11: CENTRE_FORWARD,
  },
  [FORMATION_343]: {
    1: KEEPER,
    2: CENTRE_BACK_RIGHT,
    3: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    5: SIDE_MIDFIELD_RIGHT,
    6: CENTRE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD_LEFT,
    8: SIDE_MIDFIELD_LEFT,
    9: WINGER_RIGHT,
    10: CENTRE_FORWARD,
    11: WINGER_LEFT,
  },
  [FORMATION_343D]: {
    1: KEEPER,
    2: CENTRE_BACK_RIGHT,
    3: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    5: DEFENSIVE_MIDFIELD,
    6: SIDE_MIDFIELD_RIGHT,
    7: OFFENSIVE_MIDFIELD,
    8: SIDE_MIDFIELD_LEFT,
    9: WINGER_RIGHT,
    10: STRIKER,
    11: WINGER_LEFT,
  },
  [FORMATION_3511]: {
    1: KEEPER,
    2: CENTRE_BACK_RIGHT,
    3: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    5: SIDE_MIDFIELD_RIGHT,
    6: CENTRE_MIDFIELD_RIGHT,
    7: DEFENSIVE_MIDFIELD,
    8: CENTRE_MIDFIELD_LEFT,
    9: SIDE_MIDFIELD_LEFT,
    10: OFFENSIVE_MIDFIELD,
    11: CENTRE_FORWARD,
  },
  [FORMATION_352]: {
    1: KEEPER,
    2: CENTRE_BACK_RIGHT,
    3: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    5: WING_BACK_RIGHT,
    6: DEFENSIVE_MIDFIELD_RIGHT,
    7: OFFENSIVE_MIDFIELD,
    8: DEFENSIVE_MIDFIELD_LEFT,
    9: WING_BACK_LEFT,
    10: CENTRE_FORWARD_RIGHT,
    11: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_41212]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: DEFENSIVE_MIDFIELD,
    7: SIDE_MIDFIELD_RIGHT,
    8: OFFENSIVE_MIDFIELD,
    9: SIDE_MIDFIELD_LEFT,
    10: STRIKER_RIGHT,
    11: STRIKER_LEFT,
  },
  [FORMATION_4132]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: DEFENSIVE_MIDFIELD,
    7: SIDE_MIDFIELD_RIGHT,
    8: OFFENSIVE_MIDFIELD,
    9: SIDE_MIDFIELD_LEFT,
    10: CENTRE_FORWARD_RIGHT,
    11: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_4141]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: DEFENSIVE_MIDFIELD,
    7: SIDE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_RIGHT,
    9: CENTRE_MIDFIELD_LEFT,
    10: SIDE_MIDFIELD_LEFT,
    11: STRIKER,
  },
  [FORMATION_4222]: {
    1: KEEPER,
    2: WING_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: WING_BACK_LEFT,
    6: DEFENSIVE_MIDFIELD_RIGHT,
    7: DEFENSIVE_MIDFIELD_LEFT,
    8: OFFENSIVE_MIDFIELD_RIGHT,
    9: OFFENSIVE_MIDFIELD_LEFT,
    10: CENTRE_FORWARD_RIGHT,
    11: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_4231]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: DEFENSIVE_MIDFIELD_RIGHT,
    7: DEFENSIVE_MIDFIELD_LEFT,
    8: SIDE_MIDFIELD_RIGHT,
    9: OFFENSIVE_MIDFIELD,
    10: SIDE_MIDFIELD_LEFT,
    11: CENTRE_FORWARD,
  },
  [FORMATION_4240]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: CENTRE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD_LEFT,
    8: WINGER_RIGHT,
    9: CENTRE_FORWARD_RIGHT,
    10: CENTRE_FORWARD_LEFT,
    11: WINGER_LEFT,
  },
  [FORMATION_4312]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: CENTRE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD,
    8: CENTRE_MIDFIELD_LEFT,
    9: OFFENSIVE_MIDFIELD,
    10: WINGER_RIGHT,
    11: WINGER_LEFT,
  },
  [FORMATION_4321]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: CENTRE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD,
    8: CENTRE_MIDFIELD_LEFT,
    9: OFFENSIVE_MIDFIELD_RIGHT,
    10: OFFENSIVE_MIDFIELD_LEFT,
    11: CENTRE_FORWARD,
  },
  [FORMATION_433]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: CENTRE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD,
    8: CENTRE_MIDFIELD_LEFT,
    9: WINGER_RIGHT,
    10: CENTRE_FORWARD,
    11: WINGER_LEFT,
  },
  [FORMATION_4411]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: SIDE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_LEFT,
    9: SIDE_MIDFIELD_LEFT,
    10: SECOND_STRIKER,
    11: CENTRE_FORWARD,
  },
  [FORMATION_442]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: SIDE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_LEFT,
    9: SIDE_MIDFIELD_LEFT,
    10: CENTRE_FORWARD_RIGHT,
    11: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_451]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK_LEFT,
    5: FULL_BACK_LEFT,
    6: SIDE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD,
    9: CENTRE_MIDFIELD_LEFT,
    10: SIDE_MIDFIELD_LEFT,
    11: CENTRE_FORWARD,
  },
  [FORMATION_532]: {
    1: KEEPER,
    2: WING_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: SWEEPER,
    5: CENTRE_BACK_LEFT,
    6: WING_BACK_LEFT,
    7: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD,
    9: CENTRE_MIDFIELD_LEFT,
    10: CENTRE_FORWARD_RIGHT,
    11: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_541]: {
    1: KEEPER,
    2: WING_BACK_RIGHT,
    3: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK,
    5: CENTRE_BACK_LEFT,
    6: WING_BACK_LEFT,
    7: SIDE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_RIGHT,
    9: CENTRE_MIDFIELD_LEFT,
    10: SIDE_MIDFIELD_LEFT,
    11: CENTRE_FORWARD,
  },
};

export const formationSchemaRemapped: { [key: string]: any } = {
  [FORMATION_442]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    7: SIDE_MIDFIELD_RIGHT,
    4: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_LEFT,
    11: SIDE_MIDFIELD_LEFT,
    10: CENTRE_FORWARD_RIGHT,
    9: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_433]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    7: CENTRE_MIDFIELD_RIGHT,
    4: CENTRE_MIDFIELD,
    8: CENTRE_MIDFIELD_LEFT,
    10: WINGER_RIGHT,
    9: CENTRE_FORWARD,
    11: WINGER_LEFT,
  },
  [FORMATION_451]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    7: SIDE_MIDFIELD_RIGHT,
    4: CENTRE_MIDFIELD_RIGHT,
    10: CENTRE_MIDFIELD,
    8: CENTRE_MIDFIELD_LEFT,
    11: SIDE_MIDFIELD_LEFT,
    9: CENTRE_FORWARD,
  },
  [FORMATION_532]: {
    1: KEEPER,
    2: WING_BACK_RIGHT,
    6: CENTRE_BACK_RIGHT,
    5: SWEEPER,
    4: CENTRE_BACK_LEFT,
    3: WING_BACK_LEFT,
    7: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD,
    11: CENTRE_MIDFIELD_LEFT,
    10: CENTRE_FORWARD_RIGHT,
    9: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_343]: {
    1: KEEPER,
    6: CENTRE_BACK_RIGHT,
    5: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    2: SIDE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_LEFT,
    3: SIDE_MIDFIELD_LEFT,
    10: WINGER_RIGHT,
    9: CENTRE_FORWARD,
    11: WINGER_LEFT,
  },
  [FORMATION_352]: {
    1: KEEPER,
    6: CENTRE_BACK_RIGHT,
    5: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    2: WING_BACK_RIGHT,
    7: DEFENSIVE_MIDFIELD_RIGHT,
    11: OFFENSIVE_MIDFIELD,
    8: DEFENSIVE_MIDFIELD_LEFT,
    3: WING_BACK_LEFT,
    10: CENTRE_FORWARD_RIGHT,
    9: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_4321]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    8: CENTRE_MIDFIELD_RIGHT,
    4: CENTRE_MIDFIELD,
    7: CENTRE_MIDFIELD_LEFT,
    10: OFFENSIVE_MIDFIELD_RIGHT,
    11: OFFENSIVE_MIDFIELD_LEFT,
    9: CENTRE_FORWARD,
  },
  [FORMATION_4411]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    7: SIDE_MIDFIELD_RIGHT,
    4: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_LEFT,
    11: SIDE_MIDFIELD_LEFT,
    10: SECOND_STRIKER,
    9: CENTRE_FORWARD,
  },
  [FORMATION_4231]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    8: DEFENSIVE_MIDFIELD_RIGHT,
    4: DEFENSIVE_MIDFIELD_LEFT,
    7: SIDE_MIDFIELD_RIGHT,
    10: OFFENSIVE_MIDFIELD,
    11: SIDE_MIDFIELD_LEFT,
    9: CENTRE_FORWARD,
  },
  [FORMATION_541]: {
    1: KEEPER,
    2: WING_BACK_RIGHT,
    6: CENTRE_BACK_RIGHT,
    5: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    3: WING_BACK_LEFT,
    7: SIDE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_RIGHT,
    10: CENTRE_MIDFIELD_LEFT,
    11: SIDE_MIDFIELD_LEFT,
    9: CENTRE_FORWARD,
  },
  [FORMATION_4222]: {
    1: KEEPER,
    2: WING_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: WING_BACK_LEFT,
    4: DEFENSIVE_MIDFIELD_RIGHT,
    8: DEFENSIVE_MIDFIELD_LEFT,
    7: OFFENSIVE_MIDFIELD_RIGHT,
    11: OFFENSIVE_MIDFIELD_LEFT,
    10: CENTRE_FORWARD_RIGHT,
    9: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_3421]: {
    1: KEEPER,
    6: CENTRE_BACK_RIGHT,
    5: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    2: WING_BACK_RIGHT,
    7: DEFENSIVE_MIDFIELD_RIGHT,
    8: DEFENSIVE_MIDFIELD_LEFT,
    3: WING_BACK_LEFT,
    10: OFFENSIVE_MIDFIELD_RIGHT,
    11: OFFENSIVE_MIDFIELD_LEFT,
    9: CENTRE_FORWARD,
  },
  [FORMATION_3412]: {
    1: KEEPER,
    6: CENTRE_BACK_RIGHT,
    5: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    2: WING_BACK_RIGHT,
    7: DEFENSIVE_MIDFIELD_RIGHT,
    8: DEFENSIVE_MIDFIELD_LEFT,
    3: WING_BACK_LEFT,
    9: OFFENSIVE_MIDFIELD,
    10: CENTRE_FORWARD_RIGHT,
    11: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_4132]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    4: DEFENSIVE_MIDFIELD,
    7: SIDE_MIDFIELD_RIGHT,
    8: OFFENSIVE_MIDFIELD,
    11: SIDE_MIDFIELD_LEFT,
    9: CENTRE_FORWARD_RIGHT,
    10: CENTRE_FORWARD_LEFT,
  },
  [FORMATION_4240]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    4: CENTRE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_LEFT,
    7: WINGER_RIGHT,
    9: CENTRE_FORWARD_RIGHT,
    10: CENTRE_FORWARD_LEFT,
    11: WINGER_LEFT,
  },
  [FORMATION_4312]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    7: CENTRE_MIDFIELD_RIGHT,
    4: CENTRE_MIDFIELD,
    11: CENTRE_MIDFIELD_LEFT,
    8: OFFENSIVE_MIDFIELD,
    9: WINGER_RIGHT,
    10: WINGER_LEFT,
  },
  [FORMATION_3331]: {
    1: KEEPER,
    6: CENTRE_BACK_RIGHT,
    5: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    2: DEFENSIVE_MIDFIELD_RIGHT,
    8: DEFENSIVE_MIDFIELD,
    3: DEFENSIVE_MIDFIELD_LEFT,
    10: WINGER_RIGHT,
    7: OFFENSIVE_MIDFIELD,
    11: WINGER_LEFT,
    9: CENTRE_FORWARD,
  },
  [FORMATION_4141]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    4: DEFENSIVE_MIDFIELD,
    7: SIDE_MIDFIELD_RIGHT,
    8: CENTRE_MIDFIELD_RIGHT,
    10: CENTRE_MIDFIELD_LEFT,
    11: SIDE_MIDFIELD_LEFT,
    9: STRIKER,
  },
  [FORMATION_3511]: {
    1: KEEPER,
    6: CENTRE_BACK_RIGHT,
    5: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    2: SIDE_MIDFIELD_RIGHT,
    7: CENTRE_MIDFIELD_RIGHT,
    11: DEFENSIVE_MIDFIELD,
    8: CENTRE_MIDFIELD_LEFT,
    3: SIDE_MIDFIELD_LEFT,
    10: OFFENSIVE_MIDFIELD,
    9: CENTRE_FORWARD,
  },
  [FORMATION_3142]: {
    1: KEEPER,
    5: CENTRE_BACK_RIGHT,
    4: CENTRE_BACK,
    6: CENTRE_BACK_LEFT,
    8: DEFENSIVE_MIDFIELD,
    2: WING_BACK_RIGHT,
    7: CENTRE_MIDFIELD_RIGHT,
    11: CENTRE_MIDFIELD_LEFT,
    3: WING_BACK_LEFT,
    9: STRIKER_RIGHT,
    10: STRIKER_LEFT,
  },
  [FORMATION_343D]: {
    1: KEEPER,
    6: CENTRE_BACK_RIGHT,
    5: CENTRE_BACK,
    4: CENTRE_BACK_LEFT,
    8: DEFENSIVE_MIDFIELD,
    2: SIDE_MIDFIELD_RIGHT,
    3: SIDE_MIDFIELD_LEFT,
    7: OFFENSIVE_MIDFIELD,
    10: WINGER_RIGHT,
    9: STRIKER,
    11: WINGER_LEFT,
  },
  [FORMATION_3241]: {
    1: KEEPER,
    6: CENTRE_BACK_RIGHT,
    5: SWEEPER,
    4: CENTRE_BACK_LEFT,
    2: DEFENSIVE_MIDFIELD_RIGHT,
    3: DEFENSIVE_MIDFIELD_LEFT,
    10: SIDE_MIDFIELD_RIGHT,
    7: OFFENSIVE_MIDFIELD_RIGHT,
    8: OFFENSIVE_MIDFIELD_LEFT,
    11: SIDE_MIDFIELD_LEFT,
    9: CENTRE_FORWARD,
  },
  [FORMATION_41212]: {
    1: KEEPER,
    2: FULL_BACK_RIGHT,
    5: CENTRE_BACK_RIGHT,
    6: CENTRE_BACK_LEFT,
    3: FULL_BACK_LEFT,
    4: DEFENSIVE_MIDFIELD,
    7: SIDE_MIDFIELD_RIGHT,
    11: SIDE_MIDFIELD_LEFT,
    8: OFFENSIVE_MIDFIELD,
    10: STRIKER_RIGHT,
    9: STRIKER_LEFT,
  },
};

export interface IFormationPlayer {
  readonly formationPlace: formationPlaceType;
  readonly fullName: string | null;
  readonly jerseyNumber: number | null;
  readonly imageUrl?: string;
  readonly fallbackImageUrl?: string;
  readonly playerPageLink?: string;
}
export type formationVariantsType = "LMP" | "DEFAULT";


export const getPlayerFormationPlace = (
  player: IGenericObject,
  formation: teamFormation | '',
  remapped: boolean = false,
): formationPlaceType | noFormationPlaceType => {

  const schema = remapped ? formationSchemaRemapped : formationSchemaDefault;

  return player.formationPlace && formation
    ? schema[formation][player.formationPlace] || NO_FORMATION_PLACE
    : NO_FORMATION_PLACE;
}

export const transformFormationPlayer = (player: IGenericObject, formation: teamFormation | '', variant: formationVariantsType = "DEFAULT", remapped: boolean = false): IFormationPlayer => ({
  formationPlace: getPlayerFormationPlace(player, formation, remapped) as formationPlaceType,
  fullName: variant === "LMP" ? player.fullname : player.fullName,
  jerseyNumber: player.jerseyNum,
  imageUrl: player.photoUrl ? replaceStaticEnv(player.photoUrl) : (player.photoUrl ?? null),
  fallbackImageUrl: player.fallbackPhotoUrl
    ? replaceStaticEnv(player.fallbackPhotoUrl)
    : (player.fallbackPhotoUrl ?? undefined),
  playerPageLink: player.playerPageLink,
});

const replaceStaticEnv = (url: string): string =>
  url.replace('dev.static.sky.it', 'static.sky.it').replace('test.static.sky.it', 'static.sky.it').replace('stage.static.sky.it', 'static.sky.it');